import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { BdpkFolder } from './bdpk-folder';
let BdpkTask = class BdpkTask {
    constructor() {
        this.privileges = [];
        this._folders = [];
        this.expanded = false;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get categoryId() {
        return this._categoryId;
    }
    set categoryId(value) {
        this._categoryId = value;
    }
    get categoryName() {
        return this._categoryName;
    }
    set categoryName(value) {
        this._categoryName = value;
    }
    get imagePath() {
        return this._imagePath;
    }
    set imagePath(value) {
        this._imagePath = value;
    }
    get createDate() {
        return this._createDate;
    }
    set createDate(value) {
        this._createDate = value;
    }
    get createUserId() {
        return this._createUserId;
    }
    set createUserId(value) {
        this._createUserId = value;
    }
    get createUserName() {
        return this._createUserName;
    }
    set createUserName(value) {
        this._createUserName = value;
    }
    get changeDate() {
        return this._changeDate;
    }
    set changeDate(value) {
        this._changeDate = value;
    }
    get isFavorite() {
        return this._isFavorite;
    }
    set isFavorite(value) {
        this._isFavorite = value;
    }
    get folders() {
        return this._folders;
    }
    set folders(value) {
        this._folders = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkTask.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkTask.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkTask.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkTask.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "categoryId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkTask.prototype, "_categoryId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "categoryName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkTask.prototype, "_categoryName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "imagePath", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkTask.prototype, "_imagePath", void 0);
tslib_1.__decorate([
    jsonMember({ name: "createDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkTask.prototype, "_createDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "createUserId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkTask.prototype, "_createUserId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "createUserName", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkTask.prototype, "_createUserName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "changeDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkTask.prototype, "_changeDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isFavorite", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkTask.prototype, "_isFavorite", void 0);
tslib_1.__decorate([
    jsonArrayMember(Number, { emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], BdpkTask.prototype, "privileges", void 0);
tslib_1.__decorate([
    jsonArrayMember(BdpkFolder, { name: "folders", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], BdpkTask.prototype, "_folders", void 0);
BdpkTask = tslib_1.__decorate([
    jsonObject
], BdpkTask);
export { BdpkTask };
